<app-banner-alert *ngIf="alert$ | async | isBannerTypeAlert" [alert]="alert$ | async" />
<app-card-alert *ngIf="alert$ | async | isCardTypeAlert" [alert]="alert$ | async" />
